import { render, staticRenderFns } from "./AiBusinessPromoter.vue?vue&type=template&id=ccbd2916&scoped=true&"
import script from "./AiBusinessPromoter.vue?vue&type=script&lang=js&"
export * from "./AiBusinessPromoter.vue?vue&type=script&lang=js&"
import style0 from "./AiBusinessPromoter.vue?vue&type=style&index=0&id=ccbd2916&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/jason/development/social-marketing-recovered/client/node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccbd2916",
  null
  
)

export default component.exports